export default `---
slug: software-engineering
title: "Software Engineering"
year: 2020
category: university
featured: false
tags: [Python, Agile, TDD, Pair Programming, KTH]
thumbnail: /images/projects/8_gpt_image.png
description: "KTH: learning Agile, pair programming and test-driven development — and then promptly discovering that no company actually does Agile."
relatedLinks:
  - label: "Erasmus @ KTH Stockholm"
    href: /career/erasmus-kth
---

![Student with friends doing CNNs](/images/projects/8_gpt_image.png)

During my Erasmus in Stokholm, I decided to focus on Machine Learning, and Software Engineering was a good opportunity to build a solid background (*plus it was a mandatory one back in PoliMi, so I had to take it anyway....*).
In the class we covered the traditional and modern methods for software engineering, *and let me tell you something: none of the companies I worked for is actually doing Agile!*
At the end of the class there was a project to do: plan the development of a basic management platform and develop it using modern techniques.
The application needed a basic database and GUI, and we did it in Python trying to follow "pair programming" and "test driven development".
*The most tech savvy of you will be thinking "why use Python for a front end application?" and you would be completely right. The thing is, the choice was between Python and Java. 'nough said*
`;
